import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { StaffDetailsFeatureState } from '../interfaces/shared.interface';
import { StaffDetailsAPIActions } from '../actions/staff-details.actions';
import { Division } from '../../shared/enums';

const initialState: StaffDetailsFeatureState = {
  isLoaded: false,
  email: '',
  name: '',
  staffNumber: '',
  division: Division.notDefined,
  loginDate: null,
  previousLoginDate: null,
  firstShiftDate: '',
  hasNmcSkill: false,
  hasNmbiSkill: false,
  hasHcpcSkill: false,
  hasHcaSkill: false,
  hasUniformSkill: false,
  hasMidwifeSkill: false,
};

const reducer: ActionReducer<StaffDetailsFeatureState> = createReducer(
  initialState,
  on(
    StaffDetailsAPIActions.loadedStaffDetailsSuccessfully,
    (state, { staffDetails }): StaffDetailsFeatureState => ({
      ...staffDetails,
      isLoaded: true,
    }),
  ),
);

export function staffDetailsReducer(
  state: StaffDetailsFeatureState = initialState,
  action: Action,
): StaffDetailsFeatureState {
  return reducer(state, action);
}
